import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from "@angular/material/dialog";
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatButton } from '@angular/material/button';
import { TranslocoModule } from '@ngneat/transloco';

@Component({
    selector: 'app-send-stats-dialog',
    templateUrl: './send-stats-dialog.component.html',
    styleUrls: ['./send-stats-dialog.component.scss'],
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatDialogActions, MatButton, MatDialogClose, TranslocoModule]
})
export class SendStatsDialogComponent {
  data = inject(MAT_DIALOG_DATA);

  titleKey: string;
  descriptionKey: string;
  cancelKey: string;
  actionBtnKey: string;

  constructor() {
    const data = this.data;

    this.titleKey = data.titleKey;
    this.descriptionKey = data.descriptionKey;
    this.cancelKey = data.cancelKey;
    this.actionBtnKey = data.actionBtnKey;
  }
}
